export default __webpack_public_path__ + "static/fly-man-9a0dbafcea254141da4a62ab1f78737d.png";